export default __webpack_public_path__ + "static/media/messenger.f309ce5e.svg";